export const maxWidth = "820",
    mql = window.matchMedia(`(max-width: ${maxWidth}px)`);
